import { Stack, Typography, useTheme } from "@mui/material";
import { Icon } from "../Icon";

type Props = {
	value: boolean;
	label: string;
};

const ValidationField = ({ value, label }: Props): React.ReactNode => {
	const theme = useTheme();

	return (
		<Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
			{value === true ? <Icon name="valid" color={theme.palette.success.main} /> : <Icon name="invalid" color={theme.palette.warning.main} />}
			<Typography variant="caption" color={value === true ? "success" : "warning"} sx={{ paddingTop: "1px" }}>
				{label}
			</Typography>
		</Stack>
	);
};

export { ValidationField };
